define('areas/navigationmanager/models/dto',["require", "exports"], function (require, exports) {
    "use strict";
    var Navigation = (function () {
        function Navigation() {
        }
        return Navigation;
    }());
    exports.Navigation = Navigation;
    var ModuleInfo = (function () {
        function ModuleInfo() {
            ko.track(this);
        }
        ModuleInfo.from = function (data) {
            var item = new ModuleInfo();
            item.templateId = data.templateId;
            item.uniqueItemId = data.rowKey;
            item.name = data.name;
            item.memberType = data.memberType;
            return item;
        };
        return ModuleInfo;
    }());
    exports.ModuleInfo = ModuleInfo;
});

